import React from 'react';
import { ChannelJoinButton, ChannelName, ChannelProfileImage } from '../ChannelProfileInfo';
import PropTypes from 'prop-types';
import { ImageCreateChannel } from '../../rootAccess';

function ExploreChannelItem({ item, searchText }) {
   const {name,channelId}=item;
   return (
      <>
         <div className="channelListBlock">
            <div className="channelListBox">
               <ul>
                  <li>
                     <div className="channelList">
                        <figure>
                           <ChannelProfileImage alt={name} channelId={channelId} defaultImg={ImageCreateChannel} />
                        </figure>
                        <div className="channelDetails">
                           <ChannelName
                              channelId={channelId}
                              channelName={name}
                              className="channel-name"
                              searchText={searchText}
                              channelStatus="explore"
                           />
                           <p>2.2L followers</p>
                        </div>
                        <ChannelJoinButton channelId={channelId} className="join-button" />
                     </div>
                  </li>
               </ul>
            </div>
         </div>
      </>
   );
}

export default ExploreChannelItem;

ExploreChannelItem.propTypes = {
   item: PropTypes.object,
   searchText: PropTypes.string,
};
